import { Injectable, InjectionToken, inject } from '@angular/core';
import { CONSUMER_TYPE, ConsumerType } from '../../domain/consumer-type.domain';

export const FEATURE_FLAGS = new InjectionToken<FeatureFlags>('featureFlags');

export type FeatureFlags = Record<string, boolean | number | string | Date>;

@Injectable({
  providedIn: 'root'
})
export class IfFeatureService {
  private readonly featureFlags = inject<FeatureFlags>(FEATURE_FLAGS);
  private readonly consumerType = inject<ConsumerType>(CONSUMER_TYPE);

  getFeatureFlag< T extends boolean | number | string | Date>(key: string): T {
    if (this.featureFlags !== undefined) {
      return this.featureFlags[key] as T;
    }
    return undefined;
  }

  getMobileFeature(nativeFeaturesValue: string): boolean {
    let featuresFromNative = false;
    if (this.consumerType.features !== undefined) {
      featuresFromNative = this.consumerType.features.includes(nativeFeaturesValue);
    }
    return featuresFromNative;
  }
}
